import { ReactNode, useEffect, useRef } from 'react';
import { Tab } from '@headlessui/react';

export interface ITab {
  label: string | ReactNode;
  component: ReactNode;
  disabled?: boolean;
}

export function Tabs({
  tabs,
  index,
  listClassName,
  onChange,
}: {
  index?: number;
  tabs: ITab[];
  listClassName?: string;
  onChange?: (index) => void;
}) {
  //load the first menu
  useEffect(() => {
    if (onChange) onChange(0);
  }, []);

  if(!tabs) return null;

  return (
    <div className={'h-full flex flex-col max-h-full '}>
      <Tab.Group selectedIndex={index} onChange={onChange ? onChange : null}>
        <Tab.List className={`w-full flex flex-1 ${listClassName}`}>
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              id={`tab_${index}`}
              disabled={tab.disabled}
              className={({ selected }) =>
                ` ${selected ? 'border-slate-700' : 'border-transparent'} ${
                  tab.disabled ? 'opacity-60' : ''
                } whitespace-nowrap sm:px-5 py-2 border-b-2 focus:outline-none mx-2`
              }
            >
              {tab.label}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className={'h-full flex flex-col grow'}>
          {tabs.map((tab, index) => (
            <Tab.Panel className={'h-full flex flex-col grow'} key={index}>
              {tab.component}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
